/**
 * Simple HttpError class
 */
export class HttpError extends Error {
    public status: number; // HTML Codes
    public message: string = '';

    /**
     *
     * @param {number} status - The HTML status code
     * @param {string} message - This is the message shown to the client
     */
    constructor(status: number, message: string) {
        super(message);

        // this.message set in constructor
        this.name = 'HttpError';
        this.status = status;

        Error.captureStackTrace(this, HttpError);
    }
}